import { useEffect, useState } from "react"
import { Input, Button, message } from "antd"
import { useNavigate, useParams } from "react-router-dom"
import AutoCompleteBox from "../../../components/AutocompleteBoxNew/AutocompleteBox"
import apiClient from "../../../Utils/apiClient"
import PanelLayout from "../../../Layout/PanelLayout"

const GroupDevicesForm = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const isEditMode = !!id
  const title = isEditMode ? "Edit Group" : "Add Group"

  const [groupName, setGroupName] = useState("")
  const [appGroupId, setAppGroupId] = useState("")
  const [appGroupOptions, setAppGroupOptions] = useState([])
  const [newName, setNewname] = useState("")

  useEffect(() => {
    if (isEditMode) {
      getGroupData(id)
    }
  }, [id])

  const getGroupData = async (groupId) => {
    try {
      const res = await apiClient(`device-grouping/getGroupById/${groupId}`)
      if (res?.success) {
        const group = res.group
        setGroupName(group.name)
        setNewname(group.name)

        const appGroupId =
          group.requiredApplicationsGroup?._id ||
          group.requiredApplicationsGroup
        const appGroupName = group.requiredApplicationsGroupData?.name

        setAppGroupId(appGroupId)

        setAppGroupOptions([
          {
            label: appGroupName,
            value: appGroupId,
          },
        ])
      }
    } catch (err) {
      message.error("Failed to fetch group data")
    }
  }

  const handleSubmit = async () => {
    if (!newName) {
      return message.warning("Please fill all required fields")
    }

    const payload = {
      newName: newName,
      name: groupName ? groupName : newName,
      requiredApplicationsGroup: appGroupId || null,
    }

    try {
      const endpoint = isEditMode
        ? `device-grouping/update`
        : "device-grouping/add"
      const method = "POST"

      const res = await apiClient(endpoint, method, payload)

      if (res?.success) {
        message.success(res.message)
        navigate("/group-devices")
      } else {
        message.error(res?.message || "Operation failed")
      }
    } catch (err) {
      message.error("Something went wrong")
    }
  }

  return (
    <PanelLayout
      title={title}
      subtitle="Name the group and optionally link an application group."
    >
        <label style={{ display: "block", marginBottom: 6, fontWeight: 500 }}>
          Group Name
        </label>
        <Input
          placeholder="Enter group name"
          value={newName}
          onChange={(e) => setNewname(e.target.value)}
          className="mb-3"
          size="large"
        />

        <label style={{ display: "block", marginBottom: 6, fontWeight: 500 }}>
          Application Group
        </label>

        <AutoCompleteBox
          className="w-100 mb-3"
          name="name"
          endPoint="group-Applications"
          placeholder="Search Application Group"
          value={appGroupId}
          label={appGroupOptions[0]?.label || ""}
          options={appGroupOptions}
          onSelect={(value, option) => {
            setAppGroupId(value)
          }}
        />

        <Button type="primary" size="large" onClick={handleSubmit}>
          {isEditMode ? "Update Group" : "Create Group"}
        </Button>
    </PanelLayout>
  )
}

export default GroupDevicesForm
